module.exports = __webpack_public_path__ + "static/media/canara.3d0418fb.png";